import { createContext } from 'react';
import type { Client } from '../types/Client';

type ContextProps = {
  /**
   * brand name of the app
   */
  brand: Brand;
  /**
   * set the brand name of the app
   */
  setBrandName?: (newBrand: Brand) => void;
  children?: React.ReactNode;
  client?: Client;
  /**
   * returns true if impersonatorEmail, impersonatorUserToken exists and isPostingPathAdmin is true
   */
  isImpersonator: boolean;
  /**
   * returns true if we detect the native app
   * (the zillow native app renders renter-hub in a webview)
   */
  isInWebView: boolean;
  /**
   * returns true if mobileDetect.mobile() is true, regardless of screenwidth
   */
  isMobileDevice?: boolean;
  /**
   * returns true if isMobile (from mobileDetect) OR if screenwidth is less than 1024
   */
  isMobileView: boolean;
  /**
   * pathsManifest object
   */
  paths: Record<any, any>;
};

/**
 * AppContext stores app specific data, not specific to the inbox page.
 */
export const AppContext = createContext<ContextProps>({} as ContextProps);
export const AppContextProvider = AppContext.Provider;
